import Device from '../Device';
import vp from '../../../services/api/vp';
import { hwh } from './Common';

const questions = hwh.concat([{
  type: 'ao-smith-pairing-code',
  name: 'aoSmithPairingCode',
  model: 'aoSmithPairingCode',
  label: 'modalAoSmithPairing.state.introduction',
  show: (values, parent) => Boolean(parent.allQuestionsValid),
  active: true,
  mfg: 'aosmith',
  subBrand: 'state',
  validation: 'required',
}]);

const addDevice = async (values, context) => null;

const state = new Device('state', { mfg: 'aosmith', questions, addDevice });

export default state;
